<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم خروج تجهیزات بهفا</h5>


    <br />
    <br />

    <ul>
      <li>قبل از اسکن در کادر مربوطه کلیک کنید</li>
      <li>برای بررسی کد اسکن شده می توانید کلیک Enter را فشار دهید</li>
      <li>برای پاک کردن فرم مربوطه می توانید کلیک ESC را فشار دهید</li>

    </ul>

    <br/>
    <br/>

    <form>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> علت خروج تجهیز <i class="fa fa-arrow-down"></i> </label>
          <select class="custom-select" [(ngModel)]="DowloadType" name="DowloadType" (change)="OnChange_DowloadType()">
            <option value="1">برای انجام ماموریت در محل مشتری</option>
            <option value="2">برای کالیبراسیون تجهیز</option>
            <option value="3">برای تعمیر تجهیز</option>
            <option value="4">برای انجام کنترل میانی تجهیز</option>
            <option value="5">برای آزمون مهارت یا مقایسات بین آزمایشگاهی</option>
          </select>
        </div>
      </div>
      <div class="row" *ngIf="DowloadType=='1'">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> انتخاب ماموریت </label>
          <select class="custom-select" (change)="ReadData_Mission_Device()" [(ngModel)]="LetterSchedules" name="LetterSchedules">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Mission" [value]="item.id" >
              شماره حکم {{item.userDsc}} - نامه شماره {{item.code}} تاریخ {{item.title}} - ساعت {{item.dsc}}
            </option>

          </select>
        </div>
      </div>

      <div class="table-responsive" *ngIf="DataList_Mission_Device.length>0">
        <br/>
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه سیستم</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>کمد</th>
              <th>وضیعت</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Mission_Device">
              <td>{{DataList_Mission_Device.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td class="EnglishClm">{{item.technicalDsc}}</td>
              <td>
                <p *ngIf="!item.status" style="color: red;"> خروج ثبت نشده است <i class="fa fa-times-circle"></i> </p>
                <p *ngIf="item.status" style="color: green;"> خروج ثبت شده است <i class="fa fa-check-circle"></i> </p>
              </td>

            </tr>
          </tbody>
        </table>
        <br/>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> قبل از اسکن QR Code در کادر پایین کلیک کنید <i class="fa fa-arrow-down"></i>
          </label>
          <input #QRCodeInputDownload type="text" (keyup.enter)="QRCodeInputDownload_Enter()"
            (keyup.esc)="QRCodeInputDownload_Esc()"
            style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
            placeholder="اینجا کلیک کنید ...">
          <p [hidden]="!Procssing"> لطفا صبر نمائید ... <i class="fa fa-spin fa-refresh"></i> </p>

        </div>
      </div>
      <div class="row">
        <p style="font-size: 20px;text-align: center;margin: auto;">
          اینجانب <b>{{Fullname}}</b> تمامی تجهیزاتی که طبق لیست ذیل در مورخ <b>{{nowDate}} </b>
          از آزمایشگاه بهینه فرایند آزما خارج نموده‌‌ام، صحیح و بدون عیب می‌باشد.
          <br />
          <br />
          <input type="checkbox" [checked]="Check_Message" [(ngModel)]="Check_Message" name="Check_Message" />
          <b>تایید می نمایم</b>
        </p>

      </div>

      <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDownload()" type="button"
        [disabled]="!Check_Message || Info_Download_List.length==0" class="btn btn-success" style="margin-left: 5px;"><i
          class="fa  fa-plus-circle"></i> ثبت خروج تجهیزات اسکن شده </button>


      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDownload_Enter()" type="button"
         class="btn btn-info" style="margin-left: 5px;"><i
          class="fa  fa-plus-circle"></i> بررسی شناسه تجهیز </button>

      <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button" class="btn btn-danger"
        style="margin-left: 5px;"><i class="fa  fa-recycle"></i> شروع مجدد  </button>

      <button routerLink="/DeviceBehfaDownloadUpload" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>

    <br />
    <br />

    <div class="row" *ngIf="Info_Download_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>کد تجهیز</th>
                <th>سریال تجهیز</th>
                <th *ngIf="!FormSubmitted">QR Code</th>
                <th *ngIf="FormSubmitted">پیغام سیستم</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Download_List">
                <td>{{Info_Download_List.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td *ngIf="item.id==0">{{item.dsc}}</td>
                <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                <td>
                  <button *ngIf="!FormSubmitted" (click)="Info_Download_Remove(Info_Download_List.indexOf(item))"
                    class="btn btn-danger"><i class="fa fa-remove"></i> حذف </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
</div>
